import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "alert-beta-list",
  class: "alertBeta"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(".")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.hasBeta)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Icon, {
          name: "smile-wink",
          prefix: "fas"
        }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('pages.theme-list.alerts.beta-experience')), 1),
          _createElementVNode("a", {
            id: "list-link",
            href: "#",
            target: "_self",
            class: "alertBeta__emphasis",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activeClassicList && _ctx.activeClassicList(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('pages.theme-list.alerts.back')), 1),
            _renderSlot(_ctx.$slots, "default"),
            _hoisted_2
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}